import { render, staticRenderFns } from "./payment_fee.vue?vue&type=template&id=29f8d151&"
import script from "./payment_fee.vue?vue&type=script&lang=js&"
export * from "./payment_fee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports